import React from 'react';
import iconLogo from '@assets/icons/logo.svg';

export const Logo = () => (
  <span>
    <img src={iconLogo} alt="sevenapps logo" />
  </span>
);
